import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-family: ${theme.v2.font.family.primary};
    gap: 16px;
    min-height: calc(100vh - 80px);
    margin: 0 24px 16px 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
    }
  `}
`;
